export const Type = () => {
	return (
		<svg
			viewBox="0 0 32 32"
			width={24}
			height={24}
			aria-hidden="true"
			focusable="false"
			role="img"
		>
			<title>Type</title>

			<g stroke="none" fill={"rgb(44, 104, 246)"}>
				<path d="M28.34 7.06l-14-5a1 1 0 00-.92.12A1 1 0 0013 3v13.35l-2.33-2.09a1 1 0 00-1.34 0l-5.82 5.22A1.55 1.55 0 003 20.62v8.11A1.27 1.27 0 004.27 30H28a1 1 0 001-1V8a1 1 0 00-.66-.94zM11 28H9v-3h2zm4 0h-2v-3.5a1.5 1.5 0 00-1.5-1.5h-3A1.5 1.5 0 007 24.5V28H5v-7.17l5-4.49 5 4.49zm12 0H17v-7.38a1.55 1.55 0 00-.51-1.14L15 18.12V4.42l12 4.29z"></path>
				<path d="M24 13v10a1 1 0 01-2 0V13a1 1 0 012 0zM20 11v12a1 1 0 01-2 0V11a1 1 0 012 0z"></path>
			</g>
		</svg>
	);
};

export const Garage = () => {
	return (
		<svg
			viewBox="0 0 32 32"
			width={24}
			height={24}
			aria-hidden="true"
			focusable="false"
			role="img"
		>
			<title>Parking</title>
			<g stroke="none" fill={"rgb(44, 104, 246)"}>
				<path d="M28,4V28H4V4H28m0-2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2Z"></path>
				<path d="M17.56,8H11V24h4V19h2.52A5.13,5.13,0,0,0,23,13.53,5.18,5.18,0,0,0,17.56,8Zm-1,8H15V11h1.94a2.29,2.29,0,0,1,2.5,2.5C19.44,15.32,18.32,16,16.51,16Z"></path>
			</g>
		</svg>
	);
};

export const Heating = () => {
	return (
		<svg
			viewBox="0 0 32 32"
			width={24}
			height={24}
			aria-hidden="true"
			focusable="false"
			role="img"
		>
			<title>Heating</title>
			<g stroke="none" fill={"rgb(44, 104, 246)"}>
				<path d="M21 18.11V7a5 5 0 00-10 0v11.11a7 7 0 1010 0zM16 28a5 5 0 01-3.57-8.5l.57-.58V7a3 3 0 016 0v11.92l.57.58A5 5 0 0116 28z"></path>
				<path d="M17 20.18V8a1 1 0 00-2 0v12.18a3 3 0 102 0z"></path>
			</g>
		</svg>
	);
};

export const BuildIn = () => {
	return (
		<svg
			viewBox="0 0 32 32"
			width={24}
			height={24}
			aria-hidden="true"
			focusable="false"
			role="img"
		>
			<title>Year Built</title>
			<g stroke="none" fill={"rgb(44, 104, 246)"}>
				<rect x="8" y="16" width="4" height="4" rx=".5"></rect>
				<rect x="20" y="16" width="4" height="4" rx=".5"></rect>
				<rect x="14" y="16" width="4" height="4" rx=".5"></rect>
				<rect x="8" y="22" width="4" height="4" rx=".5"></rect>
				<rect x="20" y="22" width="4" height="4" rx=".5"></rect>
				<rect x="14" y="22" width="4" height="4" rx=".5"></rect>
				<path d="M25 5h-1V3a1 1 0 00-2 0v2H10V3a1 1 0 00-2 0v2H7a3 3 0 00-3 3v19a3 3 0 003 3h18a3 3 0 003-3V8a3 3 0 00-3-3zM7 7h1v2a1 1 0 002 0V7h12v2a1 1 0 002 0V7h1a1 1 0 011 1v4H6V8a1 1 0 011-1zm18 21H7a1 1 0 01-1-1V14h20v13a1 1 0 01-1 1z"></path>
			</g>
		</svg>
	);
};

export const Bath = () => {
	return (
		<svg
			viewBox="0 0 32 32"
			width={24}
			height={24}
			aria-hidden="true"
			focusable="false"
			role="img"
		>
			<title>Cooling</title>
			<path
				stroke="none"
				fill={"rgb(44, 104, 246)"}
				d="M28.49 17.71a1 1 0 00-1.23-.71l-5.06 1.34L18 16l4.2-2.34L27.26 15h.26a1 1 0 001-.71 1 1 0 00-.71-1.18l-3.13-.81 3.1-1.73a.94.94 0 00.37-1.31 1 1 0 00-1.37-.35l-3.1 1.72.84-3a1 1 0 00-.71-1.18 1 1 0 00-1.22.68L21.2 12 17 14.33V9.66l3.7-3.57a.94.94 0 000-1.36 1 1 0 00-1.41 0L17 6.93V3a1 1 0 00-2 0v4l-2.29-2.2a1 1 0 00-1.41 0 .94.94 0 000 1.36l3.7 3.5v4.67L10.8 12 9.44 7.12a1 1 0 00-1.22-.68 1 1 0 00-.71 1.18l.84 3-3.1-1.71a1 1 0 00-1.37.35.94.94 0 00.37 1.31l3.1 1.73-3.13.81a1 1 0 00-.71 1.18 1 1 0 001 .71h.26l5.03-1.34L14 16l-4.2 2.34L4.74 17a1 1 0 00-1.23.68 1 1 0 00.71 1.18l3.13.81-3.1 1.73a.94.94 0 00-.37 1.31 1 1 0 001.37.35l3.1-1.72-.84 3a1 1 0 00.71 1.18.78.78 0 00.26 0 1 1 0 001-.72L10.8 20l4.2-2.33v4.67l-3.7 3.57a.94.94 0 000 1.36 1 1 0 001.41 0l2.29-2.2v4a1 1 0 002 0v-4l2.29 2.2a1 1 0 00.71.29 1 1 0 00.7-.29.94.94 0 000-1.36L17 22.34v-4.67L21.2 20l1.36 4.87a1 1 0 001 .72.78.78 0 00.26 0 1 1 0 00.71-1.18l-.84-3 3.1 1.72a1 1 0 001.37-.35.94.94 0 00-.37-1.31l-3.1-1.73 3.13-.81a1 1 0 00.67-1.22z"
			></path>
		</svg>
	);
};

export const DeleteIcon = () => {
	return (
		<svg
			viewBox="0 0 32 32"
            width={32}
            height={32}
			aria-hidden="true"
			focusable="false"
			role="img"
		>
			<title>Trashcan</title>
			<g stroke="none" fill={"rgb(44, 104, 246)"}>
				<path d="M27 6h-5.38l-1.45-2.9A1.99 1.99 0 0018.38 2h-4.76a1.99 1.99 0 00-1.8 1.1L10.39 6H5a1 1 0 000 2h1v20a2 2 0 002 2h16a2 2 0 002-2V8h1a1 1 0 000-2zM13.62 4h4.76l1 2h-6.76zM24 28H8V8h16z"></path>
				<path d="M13 26a1 1 0 001-1V11a1 1 0 00-2 0v14a1 1 0 001 1zM19 26a1 1 0 001-1V11a1 1 0 00-2 0v14a1 1 0 001 1z"></path>
			</g>
		</svg>
	);
};
